// extracted by mini-css-extract-plugin
export default {"linksDashboard":"LinksDashboard_linksDashboard__PMeQe"};